import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table, Badge, Spinner } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getDocuments } from './viewDocuments.reducer';
import moment from 'moment';

export const ViewDocuments = ({ categoryId }) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [statusFilter, setStatusFilter] = useState('pending');
  //  ITEMS_PER_PAGE
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );
  // const docUrl = 'http://localhost:8082/doc/'; //local
  // const imageUrl='http://localhost:8082/image/'; //local
  const imageUrl = '/image/'; //dev or Prod
  const docUrl = '/doc/'; //dev  or Prod
  const loading = useAppSelector(state => state.viewDocuments.loading);
  const { entities } = useAppSelector(state => state.viewDocuments);
  const totalItems = entities.page?.totalElements;
  const pointDetailsList = entities?.page?.content;
  const pendingStatusCount = entities?.pendingStatusCount;
  const approvedStatusCount = entities?.approvedStatusCount;
  const rejectedStatusCount = entities?.rejectedStatusCount;

  const getAllDocuments = () => {
    dispatch(
      getDocuments({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        status: statusFilter,
        categoryId: categoryId,
      })
    );
  };
  useEffect(() => {
    getAllDocuments();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, statusFilter]);

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const statusColor = status => {
    status = status.toLowerCase();
    if (status === 'pending') return { color: '#92400E', bgColor: '#FEF7D6' };
    if (status === 'approved') return { color: '#166534', bgColor: '#D4F7DC' };
    if (status === 'rejected') return { color: '#991B1B', bgColor: '#FFEEEE' };
  };

  const statusButtons = [
    { label: 'Pending', apiValue: 'pending', color: '#92400E', bgColor: '#FEF7D6', count: pendingStatusCount },
    { label: 'Approved', apiValue: 'approved', color: '#166534', bgColor: '#D4F7DC', count: approvedStatusCount },
    { label: 'Addl info rqd', apiValue: 'rejected', color: '#991B1B', bgColor: '#FFEEEE', count: rejectedStatusCount },
  ];

  return (
    <>
      {loading && (
        <div
          className="overlay-loader d-flex flex-column align-items-center justify-content-center"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            zIndex: 9999,
          }}
        >
          <Spinner className="body-loader-icon" />
        </div>
      )}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-semibold mb-0">User Dashboard - PDF Approvals</h5>
        <div className="d-flex gap-2">
          {statusButtons.map(btn => (
            <Button
              key={btn.label}
              outline
              color={btn.color}
              size="sm"
              active={statusFilter === btn.apiValue}
              onClick={() => setStatusFilter(btn.apiValue)}
              style={{
                borderRadius: '10px',
                color: statusFilter === btn.apiValue ? '#fff' : '#667085',
                backgroundColor: statusFilter === btn.apiValue ? '#f7c723' : 'transparent',
                borderColor: statusFilter === btn.apiValue ? '#FACC15' : '#E1E3E5',
              }}
            >
              <div className="d-flex">
                {btn.label}: <span style={{ color: btn.color }}>{btn.count}</span>
              </div>
            </Button>
          ))}
        </div>
      </div>
      <Table responsive hover className="align-middle" size="lg">
        <thead className="table-light">
          <tr>
            <th>File Name</th>
            <th>Category</th>
            {/* <th>Description</th> */}
            <th>Points</th>
            <th>Status</th>
            <th>Submitted</th>
            {statusFilter.toLowerCase() === 'rejected' && <th>Addl info rqd</th>}
          </tr>
        </thead>
        <tbody>
          {pointDetailsList?.map((item, index) => {
            const isImage = /\.(jpg|jpeg|png)$/i.test(item.fileName);
            const fileUrl = isImage ? imageUrl + item.fileName : docUrl + item.fileName;

            return (
              <tr key={index}>
                <td>
                  {item.externalLink ? (
                    <a
                      href={item.externalLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                      title={item.externalLink}
                    >
                      <div className="d-flex align-items-center gap-2 text-primary fw-medium">
                        <FontAwesomeIcon icon="link" />
                        <span>View Link</span>
                      </div>
                    </a>
                  ) : (
                    <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                      <div className="d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon={isImage ? 'file-image' : 'file-pdf'} className={isImage ? 'text-success' : 'text-danger'} />
                        <span className="text-truncate" style={{ maxWidth: '220px' }}>
                          {item.originalFileName || item.fileName}
                        </span>
                      </div>
                    </a>
                  )}
                </td>

                <td>
                  <div className="align-items-center">{item.displayName}</div>
                </td>
                {/* <td>
                <div className="text-muted small text-truncate">{item.description}</div>
              </td> */}
                <td className="text-warning">
                  <div className="d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon="star" />
                    <span>{item.points}</span>
                  </div>
                </td>
                <td>
                  {(() => {
                    const colorData = statusColor(item.status);
                    return (
                      <span
                        className="px-3 py-2 badge rounded-pill"
                        style={{
                          backgroundColor: colorData.bgColor,
                          color: colorData.color,
                        }}
                      >
                        {/* {item.status} */}
                        {item.status?.toLowerCase() === 'rejected' ? 'Addl info rqd' : item.status}
                      </span>
                    );
                  })()}
                </td>
                <td>
                  <div className="text-muted d-flex">{item?.submittedDate ? moment(item.submittedDate).format('DD/MM/YYYY') : ''}</div>
                </td>
                {statusFilter.toLowerCase() === 'rejected' && <td className="text-muted small">{item.rejectionReason || '-'}</td>}
              </tr>
            );
          })}
          {pointDetailsList?.length === 0 && (
            <tr>
              <td colSpan={6} className="text-center py-5">
                <div className="d-flex flex-column align-items-center gap-2 text-muted">
                  <FontAwesomeIcon icon="file-circle-xmark" size="2x" />
                  <span className="fw-semibold fs-6">No documents have been uploaded yet</span>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {totalItems ? (
        <div className={pointDetailsList && pointDetailsList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default ViewDocuments;
